const stepperData = [
  "法人情報",
  "施設情報・職員情報",
  "届出内容確認",
  "機構へ提出",
];

const tableHeadList = [
  {
    headTitle: "行移動",
    className: "tkFaciltyTableChangerItem",
    align: "center",
    helpicon: true,
    helpText: "矢印で表示順序を変更可能です。",
  },
  {
    headTitle: "施設名称",
    helpText: "指定通知、許認可書又は定款等で定められている施設の名称です。",
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "施設種類",
    helpText: "指定通知、許認可書又は定款等で定められている施設の種類です。",
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "申込時職員総数",
    helpText: (
      <>
        契約申込み時における当該施設のすべての職員数です。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "加入職員数",
    helpText: (
      <>
        契約申込み時における当該施設の加入職員数です。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "雇用契約上の雇用期間1年未満職員数",
    helpText: (
      <>
        雇用契約上の雇用期間が１年未満の加入対象外となる職員数です。所定労働時間の2/3未満の職員の両方に該当する場合は、雇用期間１年未満に計上してください。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "雇用契約上の労働時間２/３未満職員数",
    helpText: (
      <>
        雇用契約上の労働時間が正職員の所定労働時間の2/3未満の加入対象外となる職員数です。雇用期間1年未満の職員の両方に該当する場合は、雇用期間１年未満に計上してください。
        <br />
        ※加入要件については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご参照ください。
      </>
    ),
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "職員情報登録状況",
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "施設情報の修正",
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
  {
    headTitle: "職員情報登録",
    className: "tkFaciltyTableChangerItem",
    align: "center",
  },
];

export { stepperData, tableHeadList };
